/** FNV-1a, 32-bit: a stable hash so an organization keeps its colour on every visit. */ function fnv1a32(text) {
    let h = 0x811c9dc5;
    for(let i = 0; i < text.length; i += 1){
        h ^= text.charCodeAt(i);
        h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h >>> 0;
}
/**
 * Deterministic categorical colour for an organization. Our own company is
 * always `ours`; collisions are acceptable because the legend and every card
 * name the organization, so colour is never the only channel.
 */ export function orgTone(ref, ownCompanyId) {
    if (ownCompanyId && ref.id === ownCompanyId) return 'ours';
    return `cat-${1 + fnv1a32(ref.id) % 8}`;
}
